module.exports = __webpack_public_path__ + "img/13a-doc-emissao-modelo.c7661bb7.png";